/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Allocate_ResourceInputs */

const en_admin_allocation_form_allocate_resource = /** @type {(inputs: Admin_Allocation_Form_Allocate_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocate Resource`)
};

const de_admin_allocation_form_allocate_resource = /** @type {(inputs: Admin_Allocation_Form_Allocate_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressource zuweisen`)
};

const es_admin_allocation_form_allocate_resource = /** @type {(inputs: Admin_Allocation_Form_Allocate_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignar recurso`)
};

const fr_admin_allocation_form_allocate_resource = /** @type {(inputs: Admin_Allocation_Form_Allocate_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribuer une ressource`)
};

/** @type {(inputs: Admin_Allocation_Form_Allocate_ResourceInputs) => LocalizedString} */
const it_admin_allocation_form_allocate_resource = en_admin_allocation_form_allocate_resource;

/** @type {(inputs: Admin_Allocation_Form_Allocate_ResourceInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_allocate_resource = en_admin_allocation_form_allocate_resource;

/** @type {(inputs: Admin_Allocation_Form_Allocate_ResourceInputs) => LocalizedString} */
const pl_admin_allocation_form_allocate_resource = en_admin_allocation_form_allocate_resource;

/** @type {(inputs: Admin_Allocation_Form_Allocate_ResourceInputs) => LocalizedString} */
const hu_admin_allocation_form_allocate_resource = en_admin_allocation_form_allocate_resource;

/** @type {(inputs: Admin_Allocation_Form_Allocate_ResourceInputs) => LocalizedString} */
const ro_admin_allocation_form_allocate_resource = en_admin_allocation_form_allocate_resource;

/**
* | output |
* | --- |
* | "Allocate Resource" |
*
* @param {Admin_Allocation_Form_Allocate_ResourceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_allocate_resource = /** @type {((inputs?: Admin_Allocation_Form_Allocate_ResourceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Allocate_ResourceInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_allocate_resource(inputs)
	if (locale === "de") return de_admin_allocation_form_allocate_resource(inputs)
	if (locale === "es") return es_admin_allocation_form_allocate_resource(inputs)
	if (locale === "fr") return fr_admin_allocation_form_allocate_resource(inputs)
	if (locale === "it") return it_admin_allocation_form_allocate_resource(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_allocate_resource(inputs)
	if (locale === "pl") return pl_admin_allocation_form_allocate_resource(inputs)
	if (locale === "hu") return hu_admin_allocation_form_allocate_resource(inputs)
	return ro_admin_allocation_form_allocate_resource(inputs)
});
export { admin_allocation_form_allocate_resource as "admin.allocation_form.allocate_resource" }